const smallCouncils = [
  { name: 'Wujal Wujal', icon: '/small-council-icons/wujalWujal.svg' },
  {
    name: 'Cherbourg',
    icon: '/small-council-icons/cherbourg.svg',
  },
  {
    name: 'Palm Island',
    icon: '/small-council-icons/palmIsland.svg',
  },
  {
    name: 'Yarrabah',
    icon: '/small-council-icons/yarrabah.svg',
  },
  {
    name: 'Woorabinda',
    icon: '/small-council-icons/woorabinda.svg',
  },
  {
    name: 'Torres Strait Island',
    icon: '/small-council-icons/torresStraitIsland.svg',
  },
  {
    name: 'Mapoon',
    icon: '/small-council-icons/mapoon.svg',
  },
  {
    name: 'Redland',
    icon: '/small-council-icons/redland.svg',
  },
  {
    name: 'Noosa',
    icon: '/small-council-icons/noosa.svg',
  },
  {
    name: 'Torres',
    icon: '/small-council-icons/torres.svg',
  },
  {
    name: 'Logan',
    icon: '/small-council-icons/logan.svg',
  },
];

export default smallCouncils;



// WEBPACK FOOTER //
// ./src/helpers/small-councils.js